import { IIconSetMap, iconSetNames as sets } from '../icon-set/IconSet';
import names from './iconNames';

import defaultAppointment from './_default/appointment.inline.svg';
import defaultCardlist from './_default/cardlist.inline.svg';
import defaultChat from './_default/chat.inline.svg';
import defaultClock from './_default/clock.inline.svg';
import defaultExit from './_default/exit.inline.svg';
import defaultGear from './_default/gear.inline.svg';
import defaultHandbag from './_default/handbag.inline.svg';
import defaultPackageClosed from './_default/packageClosed.inline.svg';
import defaultTruck from './_default/truck.inline.svg';
import defaultUserCircle from './_default/userCircle.inline.svg';
import defaultTrophy from './_default/trophy.inline.svg';

import cardWithPerson from './_narrow/cardlist.inline.svg';
import personWithSpeechBubble from './_narrow/chat.inline.svg';
import narrowExit from './_narrow/exit.inline.svg';
import narrowGear from './_narrow/gear.inline.svg';
import user from './_narrow/user.inline.svg';
import closedPackage from './_narrow/packageClosed.inline.svg';
import narrowDoubleLoop from './_narrow/subscriptions.inline.svg';
import trophy from './_narrow/trophy.inline.svg';
import narrowTruck from './_narrow/truck.inline.svg';

const iconSetMap: IIconSetMap = {
    [names.appointment]: {
        [sets.wide]: defaultAppointment,
        [sets.narrow]: null
    },
    [names.cardlist]: {
        [sets.wide]: defaultCardlist,
        [sets.narrow]: cardWithPerson
    },
    [names.chat]: { [sets.wide]: defaultChat, [sets.narrow]: personWithSpeechBubble },
    [names.clock]: { [sets.wide]: defaultClock, [sets.narrow]: narrowDoubleLoop },
    [names.exit]: { [sets.wide]: defaultExit, [sets.narrow]: narrowExit },
    [names.gear]: { [sets.wide]: defaultGear, [sets.narrow]: narrowGear },
    [names.handbag]: { [sets.wide]: defaultHandbag, [sets.narrow]: null },
    [names.trophy]: { [sets.wide]: defaultTrophy, [sets.narrow]: trophy },
    [names.packageClosed]: {
        [sets.wide]: defaultPackageClosed,
        [sets.narrow]: closedPackage
    },
    [names.truck]: { [sets.wide]: defaultTruck, [sets.narrow]: narrowTruck },
    [names.userCircle]: { [sets.wide]: defaultUserCircle, [sets.narrow]: user }
};

export default iconSetMap;
